import React from 'react';
import styled from 'styled-components';

type props = {
  color?: string;
};

const IconContainer = styled.div`
  padding: 10px;
`;

const Icon = styled.div`
  position: relative;
  width: 18px;
  height: 14px;
`;

const LineOne = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #80868b;
  ${({ color }: props) => {
    if (color) {
      return `background-color: ${color};
      `;
    }
  }}
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
`;

const LineTwo = styled.div`
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #80868b;
  ${({ color }: props) => {
    if (color) {
      return `background-color: ${color};
      `;
    }
  }}
  top: 50%;
  transform: translateY(-50%) rotate(-45deg);
`;
type Props = {
  color?: string;
};
export default function CloseIcon({ color }: Props) {
  return (
    <IconContainer>
      <Icon>
        <LineOne color={color} />
        <LineTwo color={color} />
      </Icon>
    </IconContainer>
  );
}
